import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FilterGroup } from '../../../../models/filter-group.model';
import { FilterItem } from '../../../../models/filter-item.model';
import {applyFilterAction, findSelectedFilters, isEmptyArray} from '../../../../shared/utils';
import { cloneDeep } from 'lodash-es';

@Component({
    selector: 'selected-filters',
    templateUrl: './filter-selected-group.component.html',
    styleUrls: ['./filter-selected-group.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager
})
export class FilterSelectedGroupComponent {

    @Input() showClearAllButton = false;
    @Output() removeFilter = new EventEmitter<FilterGroup[]>();

    _selectedFilters: FilterItem[] = [];
    _filterGroups: FilterGroup[];
    @Input() set filters(val: FilterGroup[]) {
        this._filterGroups = val;
        setTimeout(() => {
            this._selectedFilters = this.getSelectedFilters(this._filterGroups);
        }, 100);
    }

    private getSelectedFilters(filterGroups: FilterGroup[]): FilterItem[] {
        return findSelectedFilters(filterGroups);
    }

    remove(removedItem: FilterItem) {

        // clone the filter groups to avoid mutating the original input
        if (isEmptyArray(this._filterGroups)) {
            return;
        }

        const updatedFilterGroups  = cloneDeep(this._filterGroups);
        updatedFilterGroups.forEach( filterGroup => {
            applyFilterAction(filterGroup, (item: FilterItem) => {
                // if (Array.isArray(item.children) && item.children.length > 0) {
                //     item.selected = item.children.every(filterChild => filterChild.selected === true);
                // }
                if (item.id === removedItem.id) {
                    item.selected = false;
                }
            })
        });
        this.removeFilter.emit(updatedFilterGroups);

        // optimistically update the selected filters
        this._selectedFilters = this._selectedFilters.filter( f => f.id !== removedItem.id );

    }

    clearAll() {
        this._filterGroups.forEach( f => {
            f.clearSelection();
            f.expanded = false;
        });
        this._selectedFilters = []; // optimistically update the selected filters

        this.removeFilter.emit(this._filterGroups);
        return false;
    }

    get hasSelectedFilters(): boolean {
        return !isEmptyArray(this._selectedFilters);
    }
}
